export class Country {
  capitalGrowth: number;
  countryId: number;
  countryName: string;
  stampDuty: number;
}

export class Property {
  capitalReturn: number;
  createdDate: string;
  flagImagePath: string;
  lastModifiedDate: string;
  locationLatitude: number;
  locationLongitude: number;
  mainImageUrl: string;
  minimumInvestment: number;
  minimumInvestmentCurrencyId: number;
  minimumInvestmentCurrencySymbol: string;
  netDefinition: string;
  netRentalYield: number;
  noOfBathrooms: number;
  noOfBedrooms: number;
  percentFunded: number;
  pricePerPart: number;
  propertyAddress: string;
  propertyId: number;
  propertyListingTypeId: number;
  propertyListingTypeName: string;
  propertyStatusId: number;
  propertyStatusName: string;
  propertyName: string;
  propertyTypeId: number;
  propertyTypeName: string;
  propertyValue: number;
  countryId: number;
  countryName: string;
  totalParts: number;
  preOrderDate: string;
  liveDate: string;
  isLive: boolean;
  isMinFundingReached: boolean;
}
